import React from 'react'
import { Box, Box as LeftHeaderWrapper } from '@node-space/ui-components'
import Breadcrumbs, { type CustomBreadCrumbConfig } from 'components/Breadcrumbs'

interface HeaderProps {
  isTitleEnabled?: boolean
  breadcrumbConfig?: CustomBreadCrumbConfig[]
}

const Header = ({ isTitleEnabled, breadcrumbConfig }: HeaderProps) => {
  return (
    <header className="sticky top-0 z-30">
      <Box paddingX={16} paddingY={12} className="sm:px-6 lg:px-8">
        <Box flex align="center" justify="between" className="h-10">
          <LeftHeaderWrapper flex align="center">
            {isTitleEnabled && <Breadcrumbs customConfig={breadcrumbConfig} />}
          </LeftHeaderWrapper>
        </Box>
      </Box>
    </header>
  )
}

export default Header
